import React, { InputHTMLAttributes } from 'react'
import Input, { InputProps } from './Input'

const InputNullable: React.FC<InputProps<string | null>> = (props) => {
    return <Input placeHolder={props.placeHolder} value={props.value ?? ''} change={value => props.change(value == '' ? null : value)}/>
}

export default InputNullable